/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`/platform${this.apiVersion}/accounts`, data);
  }
}

export default new AccountAPI();
